module.exports = __webpack_public_path__ + "static/media/mainInfo_Icon_none.51317cc4.gif";